import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@/lib/api';

export const Route = createFileRoute('/protected')({
  beforeLoad: async ({ location }) => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: ProtectedPage,
});

function ProtectedPage() {
  return (
    <div>
      <div className="p-2">This is an auth protected page</div>
      <button type="button" onClick={() => {}}>
        log out
      </button>
    </div>
  );
}
